import React from 'react'
import { Button } from '~common/components/button'
import { useAppContext } from '~/app-context'
import { useCacheValue } from '~/cache-context'

export interface AutoScanButtonProps {}

export const AutoScanButton: React.FC<AutoScanButtonProps> = () => {
    const { services, storageModules } = useAppContext()
    const authState = useCacheValue('authState')

    const handleClick = async () => {
        const userId = authState?.user?.uid
        if (!userId) {
            return
        }

        const hasGoogleAccounts =
            await storageModules.auth.hasGoogleAccounts(userId)

        if (!hasGoogleAccounts) {
            services.globalEvents.emit({
                type: 'openModal',
                modalType: 'gmail-login',
            })
        } else {
            services.globalEvents.emit({
                type: 'openModal',
                modalType: 'auto-scan-modal',
            })
        }
    }

    return (
        <>
            <Button
                label="Scan Gmail"
                onClick={handleClick}
                variant="primary"
                size="medium"
                icon="arrow-down"
                maxWidth="150px"
                fullWidth
            />
        </>
    )
}
